import api from "./api";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export async function listAttendance(data) {
    try {
      const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      };
      return await api
        .post(`/studentattendance`,data, {
          headers: header,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          catcherror(error);
        });
    } catch (error) {
      catcherror(error);
    }
  }

  export async function addAttendance(data) {
    try {
      const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      };
      return await api
        .post(`/markattendance`,data, {
          headers: header,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          catcherror(error);
        });
    } catch (error) {
      catcherror(error);
    }
  }

  export async function listAllClassAttendance(date,tdate,cls,aca,rle) {
    try {
      const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      };
      return await api
        .get(`/listattendance/${date}/${tdate}/${cls}/${aca}/${rle}`, {
          headers: header,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          catcherror(error);
        });
    } catch (error) {
      catcherror(error);
    }
  }

  export async function classSecitionList(academy) {
    try {
      const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      };
      return await api
        .get(`/classsectionlist/${academy}`, { headers: header })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          catcherror(error);
        });
    } catch (error) {
      catcherror(error);
    }
  }

  export async function studentlistAttendance(fdate,tdate,cls,aca,user) {
    try {
      const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      };
      return await api
        .get(`/studentlistattendance/${fdate}/${tdate}/${cls}/${aca}/${user}`, {
          headers: header,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          catcherror(error);
        });
    } catch (error) {
      catcherror(error);
    }
  }
  function catcherror(error) {
    console.log(error);
    if (error.code === 'ECONNABORTED' || (error.message && error.message.toLowerCase().includes('timeout'))) {
      return;
    }
    if (!error.response) {
      toast.error(error.message || "Network error. Please check your connection.");
      return;
    }
    if (error.response.status === 401) {
      localStorage.clear();
      <Navigate to={"/login"} />;
    } else if (error.response.status === 422) {
      Swal.fire({
        title:
          "There are few errors occured while inserting/updating the data to the database.",
        showCancelButton: false,
        confirmButtonColor: "#d71635",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
      });
    } else if (error.response.status === 0) {
      toast.error(error.message);
    } else if (error.response.status === 500) {
      toast.error(error.response.statusText);
    } else if (
      error.response.status !== 200 &&
      error.response.data.status === false &&
      error.response.data.code !== 200
    ) {
      toast.error(error.response.data.message);
    } else if (error.request) {
      toast.error(error.request.statusText);
    } else {
      toast.error(error.message);
    }
  }